<template>
    <div class="d-flex flex-row align-center flex-wrap justify-space-between">
        <router-link to="/">
            <v-img src="@/assets/logo.png" height="40px" width="200px" to="/"></v-img>
        </router-link>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-navigation-drawer
            v-model="drawer"
            absolute
            right
            temporary
        >
            <v-list
                nav
                dense
            >
                <v-list-item-group v-if="isLogin">
                    <v-list-item>
                        <v-list-item-title>Login as {{ name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><v-btn @click="signOut">ログアウト</v-btn></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><router-link to="/">HOME</router-link></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><router-link to="/newevent">イベント作成</router-link></v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
                <v-list-item-group v-else>
                    <v-list-item>
                        <v-list-item-title><router-link to="/">HOME</router-link></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><router-link to="/signin">ログイン</router-link></v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data () {
            return {
                name: "",
                isLogin: false,
                drawer: false,
            }
        },
        created() {
            let self = this
            firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                    self.isLogin = true
                    self.name = user.email
                } else {
                    self.name = ""
                    self.isLogin = false
                }
            })
        },
        methods: {
            signOut: function () {
                firebase.auth().signOut().then(() => {
                    this.$router.push('/signin')
                })
            }
        }
    }
</script>